import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../_services';
import {ToastService} from '../../../../_services/toast.service';
import {Router} from '@angular/router';
import {AboutUsComponent} from '../../../../components/about-us/about-us.component';
import {ModalController} from '@ionic/angular';
import {LogOutComponent} from '../../../../components/log-out/log-out.component';
import {DeleteMyAccountComponent} from '../../../../components/delete-my-account/delete-my-account.component';
import {LoadingService} from '../../../../_services/loading.service';

@Component({
  selector: 'app-why-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  @ViewChild('header') header: any;
  userAccountForm: FormGroup;
  showPassword = false;
  submitted: boolean;

  constructor(public element: ElementRef,
              public router: Router,
              public userService: UserService,
              public spinner: LoadingService,
              public translate: TranslateService,
              public modalController: ModalController,
              private toast: ToastService,
              public renderer: Renderer2) {
    this.userAccountForm = new FormGroup({
      email: new FormControl({value: '', disabled: true},
        [
          Validators.required,
          Validators.email
        ]),
      profilePassword: new FormControl('',
        [
          Validators.required
        ]),
      age: new FormControl('',
        [
          Validators.required
        ]),
      postcode: new FormControl('', []),
      occupation: new FormControl('', []),
      gender: new FormControl('', []),
      customGender: new FormControl('', []),
      language: new FormControl('', []),
      customLanguage: new FormControl('', []),
      identity: new FormControl('', []),
      customIdentity: new FormControl('', [])
    });
  }

  // convenience getter for easy access to form fields
  get field(): any {
    return this.userAccountForm.controls;
  }

  ionViewWillEnter() {
    this.renderer.setStyle(this.header.el, 'webkitTransition', 'top 700ms');
  }

  onSubmit() {
    this.spinner.show();
    const profileObj = {
      age: this.userAccountForm.value.age,
      postCode: this.userAccountForm.value.postcode,
      gender: this.userAccountForm.value.gender,
      describeGender: this.userAccountForm.value.customGender,
      occupation: this.userAccountForm.value.occupation,
      firstLanguageEnglish: this.userAccountForm.value.language,
      firstLanguageDescription: this.userAccountForm.value.customLanguage,
      culturalIdentity: this.userAccountForm.value.identity,
      culturalIdentityDescription: this.userAccountForm.value.customIdentity
    };
    this.userService.updateMyProfile(profileObj)
      .subscribe((data) => {
        this.spinner.hide();
        this.toast.display('Profile updated successfully');
      }, error => {
        this.toast.error('Profile couldn\'t be updated!!!');
        this.spinner.hide();
      });
  }

  didScroll(event: any) {
    if (event.detail.scrollTop >= 5) {
      this.renderer.setStyle(this.header.el, 'top', '-' + event.detail.scrollTop + 'px');
    } else {
      this.renderer.setStyle(this.header.el, 'top', '20px');
    }
  }

  ngOnInit(): void {
    // this.userAccountForm.get('email').patchValue('sri@whyable.com');
    if (this.userAccountForm.get('gender').value === '') {
      this.userAccountForm.get('gender').patchValue('notSay');
    }
    if (this.userAccountForm.get('language').value === '') {
      this.userAccountForm.get('language').patchValue('notSay');
      this.userAccountForm.get('identity').patchValue('notSay');
    }
    this.getProfile();
  }

  togglePassword(event: boolean) {
    this.showPassword = event;
  }

  gotToTop() {
    const myDiv = window.document.querySelector('#userAccount') as HTMLInputElement;
    myDiv.scroll({top: 0, behavior: 'smooth'});
  }

  getProfile() {
    this.spinner.show();
    this.userService.getMyProfile()
      .subscribe((data) => {
        this.spinner.hide();
        const userObj = data.data;
        this.userAccountForm.get('email').patchValue(userObj.email);
        this.userAccountForm.get('age').patchValue(userObj.profile.profileDetails.age);
        this.userAccountForm.get('postcode').patchValue(userObj.profile.profileDetails.postCode);
        this.userAccountForm.get('occupation').patchValue(userObj.profile.profileDetails.occupation);
        this.userAccountForm.get('gender').patchValue(userObj.profile.profileDetails.gender);
        this.userAccountForm.get('customGender').patchValue(userObj.profile.profileDetails.describeGender);
        this.userAccountForm.get('language').patchValue(userObj.profile.profileDetails.firstLanguageEnglish);
        this.userAccountForm.get('customLanguage').patchValue(userObj.profile.profileDetails.firstLanguageDescription);
        this.userAccountForm.get('identity').patchValue(userObj.profile.profileDetails.culturalIdentity);
        this.userAccountForm.get('customIdentity').patchValue(userObj.profile.profileDetails.culturalIdentityDescription);
      }, (error) => {
        console.error(error, 'error');
        this.spinner.hide();
      });
  }

  /*logOut() {
    this.router.navigate(['./map']);
  }*/

  async logOut() {
    const modal = await this.modalController.create({
      component: LogOutComponent,
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true
    });
    return await modal.present();
  }

  async deleteMyAccount() {
    const modal = await this.modalController.create({
      component: DeleteMyAccountComponent,
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true
    });
    return await modal.present();
  }
}
